/**
 * Created by yangxx on 2017/10/21.
 * 定义引线标注
 */
'use strict';
define([
    './TailedDom',
    '../../utils/CommonUtil',
    '../../utils/RenderUtil',
    '../../utils/SpatialOPUtil',
    '../../utils/GeometryUtil',
    '../../g2'
], function(
    TailedDom,
    CommonUtil,
    RenderUtil,
    SpatialOPUtil,
    GeometryUtil,
    g2
){
    var TailedLabel=TailedDom.extend({
        options:{
            //div容器id
            domContainer:'emap-tailedlabel-container',
            tailLength:100,
            //引线在标注上的位置，可选值 auto：自动在角上，center：水平方向居中
            tailAlign:'auto',//
            tailAngle:45,
            //div最小高度
            minHeight:15,
            minWidth:50,
            //dom 的标签
            domTag:'span'
        },
        /**
         *
         * @param options
         * @param options.map {G.Map}　－　必填，地图对象
         * @param options.layer {g2.lys.Layer} -必填，图层
         * @param options.label {String} -　必填，文本内容
         * @param options.geometry {wkt/GeoJSON} －　必填，引线指向图形坐标，要求坐标系与map一致
         * @param options.tailLength {Number} - 必填，引线长度，单位像素
         * @param options.tailAlign {String} - 可选，引线在标注上的位置，可选值 auto：自动在角上，center：水平方向居中
         * @param options.tailAngle {Number} -必填，引线与所指图形上的锚点的正北方向沿顺时针方向的夹角，单位度
         * @param options.symbol {Object} -可选，引线样式
         * @param options.showArrow {Boolean} -可选，是否显示箭头，默认为false
         * @param options.arrowSymbol {Object} -可选，箭头样式，默认与引线样式一致
         * @param options.arrowShape {String} -可选，箭头形状，默认为'triangle'，
         *          可选值为'line'=线、'triangle'=三角形
         * @param options.arrowLength {Number} 可选，箭头长度
         * @param options.arrowScale {Number} 可选，箭头长与线段长度比，默认为0.2；
         * 		  只有未指定arrowLength参数的情况下此参数才有效；
         * @param options.arrowAngle {Number} 可选，箭头与线段夹角，单位为度，默认为30度
         * @param options.domId {String} -可选，容器id，默认自动生成uuid
         * @param options.domClassName {String} -可选，容器样式，默认为空
         */
        initialize:function(options){
            TailedDom.prototype.initialize.call(this,options);
            //
        },
        /**
         * 销毁
         */
        destroy:function(){
            TailedDom.prototype.destroy.call(this);
        }
    });

    /**
     * 内部方法
     */
    TailedLabel.include({
        //获取dom 锚点的位置，根据连线角度
        _getDomAnchorPos:function(){
            var angle=this.options.tailAngle;
            var map={
                //bottom left
                '[0,90)':{
                    xVar:0,
                    yVar:-1
                },
                //top left
                '[90,180)':{
                    xVar:0,
                    yVar:0
                },
                //top right
                '[180,270)':{
                    xVar:-1,
                    yVar:0
                },
                //bottom right
                '[270,360)':{
                    xVar:-1,
                    yVar:-1
                }
            };
            var pos={};
            for(var key in map){
                if(CommonUtil.assertWithin(angle,key)){
                    pos=map[key];
                    break;
                }
            }
            if(this.options.tailAlign==='center'){
                //水平居中
                pos.xVar=-0.5;
            }
            return pos;
        },
    });
    /**
     * 对外方法
     */
    TailedLabel.include({

    });
    return TailedLabel;
});
